import { observable, computed } from 'mobx';
import { IAddress } from '../../../api/Interfaces';

export class Address {
    @observable public city: string;
    @observable public country: string;
    @observable public countryCode: string;
    @observable public county: string;
    @observable public description: string;
    @observable public neighbourhood: string;
    @observable public postalCode: string;
    @observable public state: string;
    [key: string]: string;

    public static fromJSON(data: IAddress) {
        const address = new Address();

        address.city = data.city;
        address.country = data.country;
        address.county = data.country;
        address.description = data.description;
        address.neighbourhood = data.neighbourhood;
        address.postalCode = data.postal_code;
        address.state = data.state;

        return address;
    }

    @computed
    public get formattedAddress() {
        const addressData = [this.neighbourhood, this.city, this.state, this.postalCode].filter(
            (item) => item && item.toLowerCase() !== 'n/a'
        );

        return addressData.join(', ');
    }
}
